<aside 
(window:resize)="onResize()" [class.menu-mobile-container]="this.getIsMobile()"
     [hidden]="!this.getIsOpen()" [class.menu-tablet-container]="this.getIsTablet()">
    <div>
        <div class="d-flex flex-column flex-shrink bg-white">
            <div href="/" style="background: white; z-index: 2;" class="d-flex align-items-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none" 
            [class.desktop-icon]="this.getIsDesktop() "[class.tablet-icon]="this.getIsTablet() "
            >
                <a [class.mobile-background]="this.getIsMobile()"></a>
                <a [class.rectangle]="this.getIsMobile()"></a>
                <a>
                    <div class="shadow-icon" [class.shadow-Tablet]="this.getIsTablet()">
                    <img class="icon-Desktop" *ngIf="this.getIsDesktop() || this.getIsTablet() "  [class.desktop-logo]="this.getIsDesktop()" [class.mobile-logo]="this.getIsMobile()"
                        [class.tablet-logo]="this.getIsTablet()" src="/assets/imgs/logo-ssvmn.png" />
                        <img *ngIf="this.getIsMobile()"  [class.icon-tablet]="this.getIsTablet()" [class.mobile-logo]="this.getIsMobile()"
                        [class.tablet-logo]="this.getIsTablet()" src="/assets/imgs/logo-ssvmn.png" /></div>
                </a>
                <a [hidden]="!this.getIsMobile()" class="cancel js-menu-toggle active" data-toggle="collapse"
                    data-target="#main-navbar" (click)="hideMenu()">
                    <i class="fa fa-times fa-2x" aria-hidden="true"></i>
                    <span></span>
                </a>
            </div>
            <div>
                <ul class="no-li-style" class="nav nav-pills flex-column mb-auto">
                    <li class="ps-0 pe-0 menu-sidebar scroll" [class.fixed-desktop]="this.getIsDesktop()" 
                    [class.scroll-Desktop]="this.getIsDesktop()" [class.scroll-Tablet]="this.getIsTablet()"
                    [class.scroll-Mobile]="this.getIsMobile()"
                        [class.fixed-menu]="this.getIsTablet()" [class.fixed-mobile]="this.getIsMobile()">
                        <h3 class="bs-text-title" [hidden]="!this.getIsMobile()"
                            [class.menu-style]="this.getIsMobile()">Menú</h3>   
                        <ul class="no-li-style" *ngFor="let node of getNodes(); let nodeInd = index;">
                            <h6 class="th-text-gray-paragraphs menu-title-style">
                                <div class="d-flex align-items-center margin-title">
                                    <div class="role-icon-container-style">
                                        <i [class]="'fa '+ node.icon" aria-hidden="true"></i>
                                    </div>
                                    <div>
                                        {{node.text}}
                                    </div>
                                    <div class="ms-auto cog-icon-container" *ngIf="node.OptNavigate">
                                        <i class="fa fa-cog cog-style short-cut-pointer" aria-hidden="true" 
                                           (click)="navigateToAction(node)"></i>
                                    </div>
                                </div>
                            </h6>
                            <li *ngFor="let child of node.childs let childInd = index;" 
                                [hidden]="!child.IsVisible"
                                [id]="this.getMenuItemId(child.text)"
                                class="menu-option-li-container element-pointer" (click)="navigateTo(child,nodeInd,childInd)">
                                <div class="menu-option d-flex align-items-center"  
                                     [class.menu-active]='child.isActive' 
                                     [class.menu-option-selected]='child.isActive' >

                                    <div class="bs-main-and-action bs-style"
                                        (click)="navigateTo(child,nodeInd,childInd)">
                                        {{child.text}}
                                    </div>
                                    <div class="ms-auto cog-icon-container-plus" *ngIf="child.OptNavigate">
                                        <i class="fa fa-plus-square fa-2x plus-style" aria-hidden="true"
                                            (click)="navigateToAction(child, $event)"></i>
                                    </div>
                                </div>
                            </li>
                            <hr class="line-style" *ngIf="nodeInd !== this.nodes.length - 1">
                        </ul>
                    </li>

                </ul>
            </div>
        </div>
        <div class="container-signout element-pointer" [hidden]="!this.getIsMobile()">
            <hr class="fixed-hr">
            <div [class.hidden-li]="this.getIsLogoutHidden()" [class.show-li]="!this.getIsLogoutHidden()"
                [class.logoFixed]="!this.getIsLogoutHidden()" class="sticky element-pointer" (click)="logOut()">
                <span class="bs-main-and-action" class="span-signout"> Cerrar sesión </span>
            </div>
        </div>
    </div>
</aside>
